import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

/**
 * shadcn Input — id/name 누락 시 React.useId() 로 자동 생성.
 * Why: DevTools "A form field element should have an id or name attribute" 경고를 컴포넌트 레벨에서 해결.
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, id, name, ...props }, ref) => {
    const generatedId = React.useId()
    const finalId = id ?? `input-${generatedId.replace(/:/g, "")}`
    const finalName = name ?? finalId
    return (
      <input
        type={type}
        id={finalId}
        name={finalName}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
